<template>
    <div>
        <b-row >
            <b-col>
                {{ node.feature.id }} {{ node.feature.description }}<span v-if="node.valueEntity">: {{ node.valueEntity.description }}</span><span v-if="node.articleAttribute && !node.articleAttribute.valueEntity"><b>({{ node.articleAttribute.value }})</b></span>
                <span v-else-if="node.articleAttribute && node.articleAttribute.valueEntity"><b>({{ node.articleAttribute.valueEntity.description }})</b></span>
            </b-col>
        </b-row>
        <div class="ml-5" v-if="node.childNodes && node.childNodes.length > 0">
            <div :key="childKey" v-for="(child,childKey) in node.childNodes">
                <article-debug-tree-node :node="child"></article-debug-tree-node>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'article-debug-tree-node',
    props: ['node']
}
</script>